module.exports = __webpack_public_path__ + "files/295576c5ae0c7b6d850470b84f470bfb.png";